import pubsubStore from "../../pubsub_store";
import loginStateStore from "../../login_state_store";

document.addEventListener("DOMContentLoaded", () => {
  const rectangleIds = [
    "#div-imp-smarttag-1888647-0",
    "#div-imp-smarttag-1888648-0",
    "#div-imp-smarttag-1888649-0",
  ];

  const overlayIds = [
    "#div-imp-smarttag-1888646-0",
    "#div-imp-smarttag-1888644-0",
  ];

  const floatingMenuClassNames = [
    ".floating-menu-module",
    ".recommend-spaces-floating-menu-module",
    ".want-to-recalls-floating-menu-module",
    ".topics-floating-menu-module",
    ".users-floating-menu-module",
    ".authors-floating-menu-module",
    ".boards-floating-menu-module",
  ];


  const isSmartPhone = app.isSmartPhone();
  const floatingMenuExists = floatingMenuClassNames.some(className => {
    return document.querySelector(className);
  });

  pubsubStore.subscribe("userLoginCompleted", args => {
    if (loginStateStore.isLoggedIn() == true) {
      rectangleIds.forEach(id => {
        const element = document.querySelector(id);
        if (element) {
          console.log("広告を削除", element);
          element.remove();
        }
      });

      overlayIds.forEach(id => {
        const element = document.querySelector(id);
        if (element) {
          console.log("オーバーレイを削除", element);
          element.remove();
        }
      });
    } else {
      setTimeout(() => {
        const credentialPickerIframe = document.querySelector("#credential_picker_iframe");
        if (credentialPickerIframe) {
          console.log("google one tap loginが表示されているので, 広告を表示しない", credentialPickerIframe);
          return;
        }

        rectangleIds.forEach(id => {
          const element = document.querySelector(id);
          if (element) {
            console.log("広告を削除", element);
            element.remove();
          }
        });

        overlayIds.forEach(id => {
          const element = document.querySelector(id);
          if (element) {
            console.log("オーバーレイを削除", element);
            element.remove();
          }
        });

        // const smartTagScript = document.createElement('script');
        // smartTagScript.src = 'https://imp-adedge.i-mobile.co.jp/smarttags/BI-XpKOVhUqPeKo-tziKHQ.js';
        // smartTagScript.async = true;
        // document.head.appendChild(smartTagScript);

        overlayIds.forEach(id => {
          const element = document.querySelector(id);
          if (element) {
            if (isSmartPhone) {
              setTimeout(() => {
                console.log("オーバーレイの位置を変更", element);
                if (floatingMenuExists) {
                  element.style.bottom = "125px";
                } else {
                  element.style.bottom = "50px";
                }
              }, 1000);
            }
          }
        });
      }, 1000);
    }
  });
});
